<section class="card p-4">
  <div class="header">
    <h2 class="header__title">Colaboradores</h2>
    <div class="search">
      <p class="search__title">Buscar colaborador:</p>
      <p-iconField iconPosition="left" class="ml-auto">
        <p-inputIcon>
          <i class="pi pi-search"></i>
        </p-inputIcon>
        <input pInputText [formControl]="tableFilter" placeholder="Nome" />
      </p-iconField>
    </div>
  </div>

  <div class="d-flex justify-content-center justify-content-md-end align-items-center flex-wrap gap-2 my-4">
    @if (canGeneratePin === true) {
      <app-button (btnClick)="generateMyPin()" styleType="outlined">Gerar / renovar meu PIN</app-button>
    }
    @if (!operatorsOnly) {
      <app-button (btnClick)="downloadReport()" styleType="outlined" icon="pi pi-download">
        Baixar Relatório
      </app-button>
    }
    @if (!readOnly) {
      <app-button (btnClick)="addEmployee()">
        <i class="pi pi-plus"></i>
        Convidar novo Colaborador
      </app-button>
    }
  </div>

  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">Visualizar convites</p-tab>
      <p-tab value="1">Visualizar colaboradores</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <app-employees-invitations-table
          [data]="eventEmployeeInvitation$ | async"
          [readOnly]="operatorsOnly || readOnly"
          (revokeInvitationClick)="handleRevokeInvitation($event)"
          (resendInviteClick)="handleResendInvite($event)"
          (editPdvPermission)="editPdvPermission($event, true)" />
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-employees-table
          [data]="eventEmployee$ | async"
          [readOnly]="operatorsOnly || readOnly"
          (removeEmployeeClick)="handleRemoveEmployee($event)"
          (editPdvPermission)="editPdvPermission($event)" />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</section>

@if (loading) {
  <app-loading />
}
